<template>
  <div>
    <div>
      <top-header></top-header>
    </div>
    <div class="content">
      <div class="content_banner">
        <div class="txt">
          <div class="txt_1">资讯跟踪</div>
        </div>
      </div>
      <div class="content_info">
        <div class="left">
          <ul
            class="infinite-list"
            v-infinite-scroll="load"
            :infinite-scroll-distance="100"
            style="overflow: auto; height: 800px"
          >
            <li
              v-for="(item, index) in tableData"
              :key="index"
              @click="getDetail(item)"
            >
              <div class="title">
                <img v-if="item.isWechat == 1" src="../assets/wx.svg" alt="" />
                <img v-if="item.isWechat == 0" src="../assets/net.svg" alt="" />
                <div v-html="item.title"></div>
              </div>

              <div class="bot">
                <div>
                  <el-tag
                    class="tag"
                    size="mini"
                    v-for="(tag, tagIdx) in item.tagList"
                    :key="tagIdx"
                  >
                    {{ tag }}</el-tag
                  >
                </div>
                <div>
                  <span>{{ item.source ? item.source : "未知来源" }}</span>
                  <span class="date">{{ item.publishTime }}</span>
                </div>
              </div>
            </li>
          </ul>
          <p v-if="loading">加载中...</p>
          <p v-if="!noMore">没有更多了</p>
        </div>
        <div class="right">
          <div class="search_1">
            <el-input
              style="width: 70%"
              v-model="newObj.title"
              placeholder="请输入"
              size="normal"
              clearable
              @clear="handleClear"
            ></el-input>

            <button class="btn" @click="search">
              <img style="width: 12px" src="../assets/搜索1.png" alt="" />
              专题内搜索
            </button>
          </div>

          <div class="right_a">
            <div class="common">所属板块</div>
            <div
              style="
                  margin-top: 10px;
                  display: flex;
                  justify-content: space-between;
                "
            >
              <el-select
                v-model="newObj.typeSolrkey"
                clearable
                placeholder="请选择"
                @change="search"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="right_a">
            <div class="common">时间范围</div>
            <div
              style="
                  margin-top: 10px;
                  display: flex;
                  justify-content: space-between;
                "
            >
              <el-date-picker
                v-model="value1"
                style="width: 64%"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="slectTime"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <cenfooter></cenfooter>
    </div>
  </div>
</template>

<script>
import topHeader from "../components/home/headears.vue";
import cenfooter from "../components/home/footers.vue";
import { getMyFollowType, getPanelQueue, postmyFollowPage } from "@/api/api.js";

export default {
  components: {
    topHeader,
    cenfooter,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      list: {
        code: "",
        categoryId: "",
        endTime: "",
        keyWord: "",
        page: 1,
        publishTime: "",
        rows: 10,
        startTime: "",
        title: "",
      },
      newObj: {
        page: 0,
        keywords: "",
        title: "",
        typeThree: "",
        publicTime: "",
        typeSolrkey: "",
      },
      obj: {},
      tableData: [],
      keywordsList: [],
      categoryList: [],
      currentValue: "全部",
      currentKeyWord: "全部",
      total: null,
      loading: false,
      noMore: false,
      options: [],
    };
  },
  mounted() {
    // this.init(true);
    this.getPanelQueue();
    window.document.title = "医学科教信息平台-资讯跟踪";
  },
  computed: {
    typeId() {
      return this.$route.query.id;
    },
    isLogin() {
      return sessionStorage.getItem("isLogin") === "1";
    },
  },
  methods: {
    // 选择时间
    slectTime(e) {
      if (!this.value1) {
        this.value1 = "";
        this.newObj.publicTime = "";
      } else {
        var Time = `${e[0]}_${e[1]}`;
        this.newObj.publicTime = Time;
      }
      this.init(true);
    },
    // 搜索
    search() {
      this.init(true);
    },
    getDetail(e) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id: e.id, type: e.type || '10' },
      });
      window.open(this.isLogin ? routerUrl.href : e.infoUrl);
    },
    async init(isClear) {
      if (isClear) {
        this.newObj.page = 1;
        this.tableData = [];
      }
      //获取文章列表
      this.obj = {
        condition: {
          typeSolrkey: this.newObj.typeSolrkey,
          publicTime: this.newObj.publicTime,
          title: this.newObj.title
        },
        order: "",
        pageNo: this.newObj.page,
        pageSize: 10,
        sidx: "",
      };

      const res = await postmyFollowPage(this.obj);
      if (res.data.list.length === 0) {
        this.noMore = false;
      } else {
        this.noMore = true;
      }
      this.loading = false;
      this.total = res.data.total;
      this.tableData = this.tableData.concat(res.data.list);
      this.tableData.map((item) => {
        let list = [];
        if (item.typeTwo) {
          let tagList = item.typeTwo.split(",");
          tagList.map((tag) => {
            if (tag.trim() === "科研诚信") {
              list.push("诚信");
            } else if (tag.trim() === "科研伦理") {
              list.push("伦理");
            } else {
              list.push(tag);
            }
          });
          item.tagList = list;
        }
        if (item.typeThree) {
          let tagList = item.typeThree.split(",");
          tagList.map((tag) => {
            list.push(tag);
          });
          item.tagList = list;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.newObj.page = val;
      this.init();
    },
    //取消搜索框
    handleClear() {
      this.newObj.title = "";
      this.init(true);
    },
    timeClear() {
      this.init();
    },
    // 无限滚动加载
    load() {
      this.loading = true;
      setTimeout(() => {
        this.newObj.page++;
        this.init();
      }, 2000);
    },
    // 获取栏目
    getPanelQueue() {
      getMyFollowType().then((res) => {
        let data = res.data.data;
        data.map((item) => {
          this.options.push({ label: item.typeName, value: item.typeSolrkeys });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  // margin-top: 32px;
  float: right;
}
.active {
  background-color: #0b70c1 !important;
  color: #fff;
}
.content {
  width: 90%;
  background-color: #fff;
  margin: 20px auto;
  padding: 20px;
  .content_banner {
    height: 160px;
    background: url(../assets/banner.png) no-repeat 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .collect {
      position: absolute;
      right: 20px;
      bottom: 15px;
      font-size: 17px;
      color: #fff;
      cursor: pointer;
    }
    .txt {
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
      text-align: center;
      .txt_1 {
        font-size: 28px;
        text-align: center;
        margin-bottom: 10px;
      }
      .text_2 {
        width: 70%;
        margin: 0 auto;
      }
    }
  }
  .content_info {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 70%;
      height: 800px;
      li {
        border-bottom: 1px solid #f0f0f0;
        padding: 10px 0;
      }
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 22px;
        margin-bottom: 10px;
        display: flex;
        cursor: pointer;
        img {
          float: left;
          width: 16px;
          height: 16px;
          margin-top: 3px;
          margin-right: 4px;
        }
      }
      .info {
        color: rgba(0, 0, 0, 0.4);
        font-size: 13px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
        white-space: normal;
        margin-bottom: 10px;
      }
      .bot {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.6);
        line-height: 18px;
        .tag {
          margin-right: 4px;
        }
        .date {
          margin-left: 10px;
        }
      }
    }
    .right {
      width: 28%;
      .search_1 {
        display: flex;
      }
      ::v-deep .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
      .btn {
        width: 30%;
        transition: 0.3s;
        border: 0;
        text-align: center;
        height: 40px;
        background-color: #0b70c1;
        font-size: 13px;
        color: #fff;
        cursor: pointer;
        border-radius: 0 5px 5px 0;
      }

      .right_a {
        margin-top: 30px;
        .common {
          width: 100px;
          color: rgba(11, 112, 193, 1);
          font-size: 16px;
          // text-align: center;
          padding-left: 10px;
          font-weight: 800;
          border-left: 4px solid rgba(11, 112, 193, 1);
        }
        .item {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item_e {
            padding: 8px;
            cursor: pointer;
            background-color: #f5f5f5;
            margin-right: 15px;
            margin-top: 15px;
          }
        }
      }
    }
  }
}

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.1);
}
</style>
